import React from "react";
import { StepContainer } from "../StepContainer/StepContainer";

export const PreviewPage = ({ steps }) => {
  return <>{steps.length > 0 && steps.map((step, id) => <StepContainer step={step} id={id} />)}</>;
};
